import React, { Component } from 'react';
import { MuiGrid, MuiMenuItem, MuiTypography } from '../../ui/MaterialUIComponents';
import { Link } from 'react-router-dom';
import theme from '../../../assests/theme'
import * as dropDownMenuList from './DropDownProfileMenuList'
class HelpMenu extends Component {
    render() {
        return (
            <MuiGrid style={{ padding: 8 }} >
                {dropDownMenuList.helpMenuList.map((menuItem) => <Link to={menuItem.route} style={theme.linkStyle}>
                    <MuiMenuItem>
                        <MuiTypography variant={theme.typographyStyles.BODY2} style={{color:theme.palette.primary.darker}}>{menuItem.name}</MuiTypography>
                    </MuiMenuItem>
                </Link>)}
            </MuiGrid>

        );
    }
}
export default HelpMenu 
